export default "__VITE_ASSET__CVFmXls7__"